import React from "react";
import OrderTable from "../Table";

const Cancelled = () => {
  return <OrderTable type="Cancelled" />;
};

export default Cancelled;
